import { ModalGenericDialogController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * User interface for debugging definition and values.
 * @example
 * ```html
 * <salaxy-data-mapper model="$ctrl.mapper"></salaxy-data-mapper>
 * ```
 */
export class DataMapper extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {
      /** The DataMapper that is shown.  */
      model: "<",

      /**
       * Type of the user interface:
       *
       * - "value-map" (default) Shows the source values in the table, target mapping is editable.
       * - "debug" Full data mapper debugger / editor UI.
       * - "source-value" Shows the source values in a table, also the validation column
       * - "target-value" Shows the target values in a table, also the validation column
       */
      type: "@",
    };

    /** Uses the ModalGenericDialogController */
    public controller = ModalGenericDialogController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/helpers/DataMapper.html";
}
